import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { firestoreConnect } from "react-redux-firebase";
import { Redirect } from "react-router-dom";
import { compose } from "redux";
import { Button, Dropdown, Icon, Loader } from "semantic-ui-react";
import AddPartner from "../components/layout/Partners/AddPartner";
import PartnersCard from "../components/layout/Partners/PartnersCard";
import PartnersFilter from "../components/layout/PartnersFilter";
import ReorderPartner from "../components/layout/Partners/ReorderPartner";
import "./SuperPartners.css";
import AddCategory from "../components/layout/Partners/AddCategory";
import DeleteCategory from "../components/layout/Partners/DeleteCategory";
const SuperPartners = (props) => {
  // State & Dispatch
  const [addPartner, setAddPartner] = useState(false);
  const [addCategory, setAddCategory] = useState(false);
  const [reorder, setReorder] = useState(false);
  const [category, setCategory] = useState("testprep");
  const [data, setData] = useState([]);
  const [save, setSave] = useState(false);
  const [deleteCategory, setDeleteCategory] = useState(null);

  const handleReorder = () => {
    if (reorder) {
      setSave(true);
      // setReArrange(false);
    }
    if (!reorder) {
      setReorder(true);
    }
  };

  //   Use Effect For Data
  useEffect(() => {
    if (category) {
      const partners = props.partners;
      const order = props.partnersOrder[category]?.order || [];
      if (Object.keys(partners).length > 0) {
        const orderedArray = order.map((e) => partners[e]);
        setData(orderedArray);
      } else setData([]);
    } else setData([]);
  }, [category, props.partners, props.partnersOrder]);
  //   Return
  if (!props.auth.isLoaded) {
    return (
      <div className="SpinnerBackground">
        <div className="SpinnerContainer">
          <Loader size="large" active inline="centered" />
        </div>
      </div>
    );
  } else if (
    props.auth.isLoaded &&
    (props.auth.email === "csanicknaudin@gmail.com" || props.superAdmin)
  ) {
    return (
      <div className="AthleteDetailsBackground cu-profile">
        <div className="AthleteDetailsBannerBar"></div>
        <PartnersFilter />
        <div className="AthleteDetailsButtonContainer event-header partner-header">
          <div className="first-div">
            <Button
              disabled={data.length < 2}
              icon={!reorder ? "sort amount up" : "checkmark"}
              color="blue"
              onClick={handleReorder}
              content={!reorder ? "Reorder" : "Save"}
            />
            <Dropdown
              onChange={(e, data) => {
                setCategory(data.value);
              }}
              disabled={reorder}
              value={category}
              options={props.categories}
              placeholder="Category"
              name="category"
              selection
            >
              <Dropdown.Menu>
                {props.categories.map((e) => {
                  return (
                    <Dropdown.Item>
                      {category !== e.value && (
                        <Icon
                          name="trash"
                          color="red"
                          className="right floated"
                          onClick={() => {
                            setDeleteCategory(e.value);
                          }}
                        />
                      )}
                      <p onClick={() => setCategory(e.value)}>{e.text}</p>
                    </Dropdown.Item>
                  );
                })}
              </Dropdown.Menu>
            </Dropdown>
          </div>
          <div className="second-div partner-btns">
            <Button
              disabled={reorder}
              icon="plus"
              color="green"
              onClick={() => setAddPartner(true)}
              content="Partner"
            />
            <Button
              disabled={reorder}
              icon="plus"
              color="teal"
              onClick={() => setAddCategory(true)}
              content="Category"
            />
          </div>
        </div>

        <div className="AthleteEventsInfoContainer common-event">
          {data && data.length < 1 && (
            <p className="not-found cu-center">There's No Data Right Now</p>
          )}
          {!reorder ? (
            <div className="team-section">
              {data &&
                data.map((partner) => <PartnersCard advocate={partner} />)}
            </div>
          ) : (
            <ReorderPartner
              category={category}
              documents={data}
              setReorderOff={() => setReorder(false)}
              handleSave={save}
              handleSaveState={(e) => setSave(e)}
            />
          )}
        </div>

        <AddPartner open={addPartner} close={() => setAddPartner(false)} />
        <AddCategory open={addCategory} close={() => setAddCategory(false)} />
        <DeleteCategory
          open={deleteCategory}
          close={() => setDeleteCategory(null)}
        />
      </div>
    );
  } else if (props.auth.isLoaded && !props.auth.email) {
    return <Redirect to={`/login`} />;
  } else if (
    props.auth.isLoaded &&
    props.auth.email &&
    (props.auth.email !== "csanicknaudin@gmail.com" || !props.superAdmin)
  ) {
    return <Redirect to={`/events`} />;
  }
  return null;
};

const mapStateToProps = (state) => {
  let testprep = [];
  let videoservices = [];
  let streaming_scoring = [];
  let motivational = [];

  const partners = state.firestore.data.partners
    ? state.firestore.data.partners
    : {};
  const partnersOrder = state.firestore.data.partnersOrder
    ? state.firestore.data.partnersOrder
    : [];

  if (
    Object.keys(partnersOrder)?.length > 0 &&
    Object.keys(partners).length > 0
  ) {
    testprep = partnersOrder?.testprep?.order
      ? partnersOrder?.testprep?.order
      : [];
    videoservices = partnersOrder?.videoservices?.order
      ? partnersOrder?.videoservices?.order
      : [];
    streaming_scoring = partnersOrder?.streaming_scoring?.order
      ? partnersOrder?.streaming_scoring?.order
      : [];
    motivational = partnersOrder?.motivational?.order
      ? partnersOrder?.motivational?.order
      : [];

    testprep = testprep.map((e) => {
      let data = null;
      if (partners[e].category === "testprep") {
        data = partners[e];
      }
      return data;
    });
    videoservices = videoservices.map((e) => {
      let data = null;
      if (partners[e].category === "videoservices") {
        data = partners[e];
      }
      return data;
    });
    streaming_scoring = streaming_scoring.map((e) => {
      let data = null;
      if (partners[e].category === "streaming_scoring") {
        data = partners[e];
      }
      return data;
    });
    motivational = motivational.map((e) => {
      let data = null;
      if (partners[e].category === "motivational") {
        data = partners[e];
      }
      return data;
    });
  }
  // Category Dropdown C0DE

  const categories = [];
  const categoriesData = state.firestore.ordered.partnersOrder;
  if (categoriesData && categoriesData.length > 0) {
    categoriesData.forEach((category, key) => {
      if (category.name) {
        categories.push({ key, text: category.name, value: category.id });
      }
    });
  }
  return {
    partners,
    partnersOrder,
    categories,
    testprep,
    videoservices,
    streamingScoring: streaming_scoring,
    motivational,
    auth: state.firebase.auth,
    superAdmin: state.auth.superAdmin,
  };
};

export default compose(
  connect(mapStateToProps),
  firestoreConnect(() => {
    const firestoreArray = [
      {
        collection: "partners",
      },
      {
        collection: "partnersOrder",
      },
    ];
    return firestoreArray;
  })
)(SuperPartners);
